import { render, staticRenderFns } from "./NumberCircle.vue?vue&type=template&id=f4aa07e2&scoped=true&"
import script from "./NumberCircle.vue?vue&type=script&lang=ts&"
export * from "./NumberCircle.vue?vue&type=script&lang=ts&"
import style0 from "./NumberCircle.vue?vue&type=style&index=0&id=f4aa07e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4aa07e2",
  null
  
)

export default component.exports